var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:({ objectFit: _vm.fit }),attrs:{"src":_vm.displaySrc,"alt":_vm.alt},on:{"error":_vm.onImageError}})
}
var staticRenderFns = []

export { render, staticRenderFns }